module.exports = __webpack_public_path__ + "static/media/Lockton_Marine_P&I_uk-pi-club.da70c900.pdf";